import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ShowerIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ShowerIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M14.2957 6.874C14.2344 4.42132 12.2417 2.45917 9.78898 2.45917C7.27492 2.45917 5.25146 4.48263 5.25146 6.96597V21.4674C5.25146 21.8047 5.52743 22.0807 5.86468 22.0807C6.20185 22.0807 6.47781 21.8047 6.47781 21.4674V6.96597C6.47781 5.15712 7.98011 3.68551 9.78898 3.68551C11.5671 3.68551 13.0081 5.12646 13.0694 6.874C10.4328 7.18058 8.34798 9.35734 8.28667 12.0859C8.28667 12.2392 8.34798 12.4232 8.47065 12.5458C8.59325 12.6685 8.74652 12.7298 8.8998 12.7298H18.496C18.6493 12.7298 18.8332 12.6685 18.9252 12.5458C19.0478 12.4232 19.1092 12.2699 19.1092 12.0859C19.0172 9.35734 16.9324 7.18058 14.2957 6.874ZM9.57433 11.5034C9.94227 9.54128 11.6285 8.06968 13.6826 8.06968C15.7367 8.06968 17.4536 9.54128 17.7908 11.5034H9.57433Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.4022 14.0168C10.0649 14.0168 9.78906 14.2927 9.78906 14.63V15.3045C9.78906 15.6418 10.0649 15.9176 10.4022 15.9176C10.7394 15.9176 11.0154 15.6418 11.0154 15.3045V14.63C11.0154 14.2927 10.7394 14.0168 10.4022 14.0168Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.6825 14.0168C13.3453 14.0168 13.0693 14.2927 13.0693 14.63V15.3045C13.0693 15.6418 13.3453 15.9176 13.6825 15.9176C14.0198 15.9176 14.2957 15.6418 14.2957 15.3045V14.63C14.2957 14.2927 14.0198 14.0168 13.6825 14.0168Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.9935 14.0168C16.6563 14.0168 16.3804 14.2927 16.3804 14.63V15.3045C16.3804 15.6418 16.6563 15.9176 16.9935 15.9176C17.3308 15.9176 17.6067 15.6418 17.6067 15.3045V14.63C17.6067 14.2927 17.3307 14.0168 16.9935 14.0168Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0267 16.8068C11.6895 16.8068 11.4136 17.0828 11.4136 17.42V18.0945C11.4136 18.4317 11.6895 18.7077 12.0267 18.7077C12.364 18.7077 12.6399 18.4317 12.6399 18.0945V17.42C12.6399 17.0828 12.364 16.8068 12.0267 16.8068Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.3378 16.8068C15.0006 16.8068 14.7246 17.0828 14.7246 17.42V18.0945C14.7246 18.4317 15.0006 18.7077 15.3378 18.7077C15.6751 18.7077 15.951 18.4317 15.951 18.0945V17.42C15.951 17.0828 15.6751 16.8068 15.3378 16.8068Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ShowerIcon;
